import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import locationMessages from './location.messages';
import Location from './location.mapper';

const functions = {
  get,
};

export default {
  ...functionsWithNotifications(functions, locationMessages),
};

const locationApi = new ApiService();

async function get(locationUuid) {
  const response = await locationApi.get(`locations/${locationUuid}`);
  return new Location(response.data.data);
}
